export class AutoActConstant {
  public static ItadakimasuSettings = {
    auto_card_signin: 'auto_card_signin',
    auto_card_signout: 'auto_card_signout',
  };

  public static AutoCardSignInValues = {
    true: 'true',
    false: 'false',
  };

  public static AutoCardSignOutValues = {
    true: 'true',
    false: 'false',
  };
}
